

import React, { useState, useEffect } from "react";
import {
    Container,
    Card,
    CardContent,
    Typography,
    Button,
    Box,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
    Divider,
    useMediaQuery,
    CircularProgress,
} from "@mui/material";
import { AddCircle, Search } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import { toast, ToastContainer } from 'react-toastify';  // Import toastify
import 'react-toastify/dist/ReactToastify.css';  // Import the CSS for Toast

const UsersInfoPage = () => {
    const [openDialog, setOpenDialog] = useState(false);
    const [editableUser, setEditableUser] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [usersData, setUsersData] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [isAdding, setIsAdding] = useState(false);
    const [isLoading, setIsLoading] = useState(false);  // Loading state
    const isMobile = useMediaQuery("(max-width:600px)");
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);


    useEffect(() => {
        fetchUsersData();
    }, []);

    const fetchUsersData = async () => {
        setIsLoading(true);
        try {
            const response = await fetch("https://gracioussacco.co.ke/gracious/api/users.php");
            const data = await response.json();
            setUsersData(data);
            setFilteredUsers(data);
        } catch (error) {
            toast.error("Error fetching users data.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleSearch = (term) => {
        setSearchTerm(term);
        const filtered = usersData.filter(
            (user) =>
                user.name.toLowerCase().includes(term.toLowerCase()) ||
                user.member_no.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredUsers(filtered);
    };

    const handleEdit = (user) => {
        const { role_name, ...finaluser } = user;//remove  role
        setEditableUser(finaluser);
        setIsAdding(false);
        setOpenDialog(true);
    };

    const handleAddMember = () => {
        setEditableUser({
            id: "",
            name: "",
            email: "",
            phone: "",
            member_no: "",
            individual_shares: 0,
            emergency_loan_balance: 0,
            normal_loan_balance: 0,
            group_shares: 0,
            welfare_funds: "",
            total_savings: "",
            principle: "",
            amount_per_installment: "",
            number_of_installments: "",
            business_loan_balance: 0,
            project_loan_balance: 0,
            normal_loan_limit: 0,
            penalty_due: 0,
            penalty_paid: 0,
            group_dividends: 0,
        });
        setIsAdding(true);
        setOpenDialog(true);
    };


    const handleClose = () => {
        setOpenDialog(false);
        setEditableUser(null);
        setIsAdding(false);
    };

    const handleSave = async () => {
        setIsLoading(true);  // Show loading indicator
        try {
            const formData = new URLSearchParams(editableUser).toString();
            console.log(formData);

            const response = await fetch(
                "https://gracioussacco.co.ke/gracious/api/users.php",
                {
                    method: isAdding ? "POST" : "PUT",
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    body: formData,
                }
            );
            const result = await response.json();


            if (result.success) {
                toast.success(isAdding ? "Member added successfully!" : "Member updated successfully!");
                if (isAdding) {
                    setUsersData([...usersData, editableUser]);
                    setFilteredUsers([...filteredUsers, editableUser]);
                } else {
                    const updatedUsers = usersData.map((user) =>
                        user.user_id === editableUser.user_id ? editableUser : user
                    );
                    setUsersData(updatedUsers);
                    setFilteredUsers(updatedUsers);
                }
                window.location.reload();
                setOpenDialog(false);
                fetchUsersData();
            } else {
                toast.error(result.message);
                fetchUsersData();
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setIsLoading(false);
            fetchUsersData();
        }
    };

    //   const handleDelete = async (id) => {
    //     setIsLoading(true);  // Show loading indicator
    //     try {
    //       // Prepare data in URL-encoded format
    //       const urlEncodedData = new URLSearchParams();
    //       urlEncodedData.append('id', id);

    //       // Send DELETE request with URL-encoded body
    //       const response = await fetch("https://gracioussacco.co.ke/gracious/api/users.php", {
    //         method: "DELETE",
    //         headers: {
    //           "Content-Type": "application/x-www-form-urlencoded",  // Set content type as URL-encoded
    //         },
    //         body: urlEncodedData.toString(),  // Convert data to URL-encoded string
    //       });

    //       const result = await response.json();
    //       console.log(result);

    //       if (result.success) {
    //         toast.success("Member deleted successfully!");
    //         const updatedUsers = usersData.filter((user) => user.id !== id);
    //         setUsersData(updatedUsers);
    //         setFilteredUsers(updatedUsers);
    //       } else {
    //         toast.error("Failed to delete member.");
    //       }
    //     } catch (error) {
    //       toast.error("Error deleting member.");
    //     } finally {
    //       setIsLoading(false);  // Hide loading indicator
    //     }
    //   };

    const handleDelete = (user) => {
        setUserToDelete(user);
        setOpenConfirmDialog(true);
    };

    const confirmDelete = async (id) => {
        setIsLoading(true);  // Show loading indicator
        try {
            // Prepare data in URL-encoded format
            const urlEncodedData = new URLSearchParams();
            urlEncodedData.append('id', id);

            // Send DELETE request with URL-encoded body
            const response = await fetch("https://gracioussacco.co.ke/gracious/api/users.php", {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",  // Set content type as URL-encoded
                },
                body: urlEncodedData.toString(),  // Convert data to URL-encoded string
            });

            const result = await response.json();

            if (result.success) {
                toast.success("Member deleted successfully!");
                const updatedUsers = usersData.filter((user) => user.id !== id);
                setUsersData(updatedUsers);
                setFilteredUsers(updatedUsers);
                fetchUsersData()
            } else {
                toast.error("Failed to delete member.");
            }
        } catch (error) {
            toast.error("Error deleting member.");
        } finally {
            setIsLoading(false);  // Hide loading indicator
        }
    };




    const handleInputChange = (field, value) => {
        setEditableUser((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const columns = [
        { field: "member_no", headerName: "Member No", flex: 1 },
        { field: "name", headerName: "Name", flex: 1.5 },
        { field: "individual_shares", headerName: "Individual Shares", flex: 1.2 },
        { field: "emergency_loan_balance", headerName: "Emergency Loan Balance", flex: 1.2 },
        { field: "normal_loan_balance", headerName: "Normal Loan Balance", flex: 1.2 },
        { field: "group_shares", headerName: "Group Shares", flex: 1.2 },
        { field: "welfare_funds", headerName: "Welfare Funds", flex: 1 },
        { field: "total_savings", headerName: "Total Savings", flex: 1 },
        { field: "principle", headerName: "Principle", flex: 1 },
        { field: "amount_per_installment", headerName: "Amount/Installment", flex: 1.5 },
        { field: "number_of_installments", headerName: "Installments", flex: 1 },
        { field: "business_loan_balance", headerName: "Business Loan Balance", flex: 1 },
        { field: "project_loan_balance", headerName: "Project Loan Balance", flex: 1 },
        { field: "normal_loan_limit", headerName: "Normal Loan Limit", flex: 1 },
        { field: "penalty_due", headerName: "Penalty Due", flex: 1 },
        { field: "penalty_paid", headerName: "Penalty Paid", flex: 1 },
        { field: "group_dividends", headerName: "Group Dividends", flex: 1 },
        {
            field: "actions",
            headerName: "Actions",
            flex: 2.5,
            renderCell: (params) => (
                <Box sx={{ display: "flex", gap: 1, padding: 1 }}>
                    <Button
                        size="small"
                        variant="outlined"
                        onClick={() => handleEdit(params.row)}
                        sx={{
                            padding: "2px 5px",
                            borderRadius: "5px",
                            border: "1px dotted rgb(20, 220, 30)",
                            cursor: "pointer",
                        }}
                    >
                        Edit
                    </Button>
                    {<Button
                        size="small"
                        variant="outlined"
                        color="error"
                        onClick={() => handleDelete(params.row.user_id)}
                        sx={{
                            padding: "2px 5px",
                            borderRadius: "5px",
                            color: "crimson",
                            border: "1px dotted rgba(220, 20, 60, 0.6)",
                            cursor: "pointer",
                        }}
                    >
                        Delete
                    </Button>}

                </Box>
            ),
        },
    ];

    return (
        <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
            {/* Loading Indicator */}
            {isLoading && (
                <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
                    <CircularProgress />
                </Box>
            )}

            {/* Toast Container */}
            <ToastContainer />

            {/* Header with Search and Add Button */}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 4,
                    gap: 2,
                }}
            >
                <Typography
                    variant="h4"
                    sx={{ fontWeight: "bold", textAlign: { xs: "center", sm: "left" } }}
                >
                    Member Information
                </Typography>
                <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                    <TextField
                        variant="outlined"
                        size="medium"
                        placeholder="Search by Name or ID"
                        value={searchTerm}
                        onChange={(e) => handleSearch(e.target.value)}
                        InputProps={{
                            endAdornment: <Search />,
                        }}
                        sx={{ flex: 1, minWidth: "300px" }}
                    />
                    <Button
                        variant="contained"
                        color="success"
                        startIcon={<AddCircle />}
                        onClick={handleAddMember}
                    >
                        Add Member
                    </Button>
                </Box>
            </Box>

            {/* Responsive View - Cards */}
            {isMobile ? (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                    {filteredUsers.length > 0 ? (
                        filteredUsers.map((user) => (
                            <Card
                                key={user.id}
                                sx={{
                                    padding: 3,
                                    boxShadow: 4,
                                    borderRadius: 4,
                                }}
                            >
                                <CardContent>
                                    <Grid container spacing={2}>
                                        {Object.entries(user).map(([key, value]) => (
                                           key !== 'user_id' && key !== 'id'  && (
                                                <Grid
                                                    item
                                                    xs={12}
                                                    key={key}
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        mb: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body1"
                                                        sx={{ fontWeight: "bold", color: "gray" }}
                                                    >
                                                        {key.replace(/([A-Z])/g, " $1")}:
                                                    </Typography>
                                                    <Typography
                                                        variant="body1"
                                                        sx={{ textAlign: "right", fontWeight: "medium" }}
                                                    >
                                                        {value}
                                                    </Typography>
                                                </Grid>
                                            )
                                        ))}
                                    </Grid>

                                    {/* Action Buttons */}
                                    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            onClick={() => handleEdit(user)}
                                        >
                                            Edit
                                        </Button>
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            color="error"
                                            onClick={() => handleDelete(user.id)}
                                        >
                                            Delete
                                        </Button>
                                    </Box>
                                </CardContent>
                            </Card>
                        ))
                    ) : (
                        <Typography variant="body1" color="textSecondary">
                            No users found.
                        </Typography>
                    )}
                </Box>
            ) : (
                // DataGrid for Desktop View
                <Card sx={{ boxShadow: 2 }}>
                    <CardContent>
                        <DataGrid
                            rows={filteredUsers}
                            columns={columns}
                            getRowId={(row) => row.user_id}
                            pageSize={5}
                            rowsPerPageOptions={[5]}
                            disableSelectionOnClick
                        />
                    </CardContent>
                </Card>
            )}

            {/* Add/Edit User Dialog */}
            <Dialog open={openDialog} onClose={handleClose} fullWidth>
                <DialogTitle>{isAdding ? "Add Member" : "Edit Member"}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        {editableUser &&
                            Object.entries(editableUser).map(([key, value]) => (
                                // Exclude specific fields like 'id' 
                                key !== 'user_id' && key !== 'id' && (
                                    <Grid item xs={12} sm={6} key={key}>
                                        <TextField
                                            label={key.replace(/([A-Z])/g, " $1")}
                                            fullWidth
                                            value={value}
                                            onChange={(e) => handleInputChange(key, e.target.value)}
                                        />
                                    </Grid>
                                )
                            ))}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleSave} color="primary">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>



            <Dialog open={openConfirmDialog} onClose={() => setOpenConfirmDialog(false)}>
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                    <Typography>Are you sure you want to delete this member?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenConfirmDialog(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button
                        onClick={async () => {
                            if (userToDelete) {
                                await confirmDelete(userToDelete);  // Proceed with deletion
                            }
                            setOpenConfirmDialog(false);  // Close the dialog
                        }}
                        color="primary"
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

        </Container>
    );
};

export default UsersInfoPage;
